import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_preferences.less'
import { getI18n } from 'client/i18n'
import Separator from 'components/common/separator'
import Checkbox from 'components/common/checkbox'

import ContributionPrefs from 'components/contribution_prefs'

const i18n = getI18n('components/pages/create/participants')

class Participants extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    untouch: PropTypes.func.isRequired,
    shareProgress: PropTypes.bool,
    shouldAutoFocus: PropTypes.bool,
  }

  render() {
    const {
      fields: {
        amountType,
        amountAtLeast,
        amountExactly,
        shareContributorsDetails,
        shareContributionsAmount,
      },
      handleSubmit,
      untouch,
      shareProgress,
      shouldAutoFocus,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div styleName="title">{i18n('title')}</div>

        <div styleName="contrib-prefs-container">
          <ContributionPrefs
            amountType={amountType}
            amountAtLeast={amountAtLeast}
            amountExactly={amountExactly}
            untouch={untouch}
            shouldAutoFocus={shouldAutoFocus}
          />
        </div>

        <Separator type="dotted" />
        <div styleName="subtitle">{i18n('share_who')}</div>
        <div styleName="checkbox-wrapper">
          <Checkbox
            name="name-photo-checkbox"
            dataNemo="name-photo-checkbox"
            label={i18n('share_name_photo')}
            onChange={shareContributorsDetails.onChange}
            value={!!shareContributorsDetails.value}
            data-pa-click="namePhotoCheckbox"
          />
        </div>
        {shareProgress && (
          <div styleName="checkbox-wrapper">
            <Checkbox
              dataNemo="amount-checkbox"
              name="amount-checkbox"
              label={i18n('share_amount')}
              onChange={shareContributionsAmount.onChange}
              value={!!shareContributionsAmount.value}
              data-pa-click="amountCheckbox"
            />
          </div>
        )}
        <div styleName="disclaimer">{i18n('share_disclaimer')}</div>

        <button
          data-nemo="create-preference-next"
          data-pa-click="next"
          className="vx_btn vx_btn-block"
          styleName="next-button"
        >
          {i18n('next')}
        </button>
      </form>
    )
  }
}

export default cssModules(Participants, styles)
